/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CancelInvitationActionResponseInvitation } from './CancelInvitationActionResponseInvitation';
import {
    CancelInvitationActionResponseInvitationFromJSON,
    CancelInvitationActionResponseInvitationFromJSONTyped,
    CancelInvitationActionResponseInvitationToJSON,
    CancelInvitationActionResponseInvitationToJSONTyped,
} from './CancelInvitationActionResponseInvitation';

/**
 * 
 * @export
 * @interface CancelInvitationActionResponse
 */
export interface CancelInvitationActionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CancelInvitationActionResponse
     */
    success?: boolean;
    /**
     * 
     * @type {CancelInvitationActionResponseInvitation}
     * @memberof CancelInvitationActionResponse
     */
    invitation?: CancelInvitationActionResponseInvitation;
}

/**
 * Check if a given object implements the CancelInvitationActionResponse interface.
 */
export function instanceOfCancelInvitationActionResponse(value: object): value is CancelInvitationActionResponse {
    return true;
}

export function CancelInvitationActionResponseFromJSON(json: any): CancelInvitationActionResponse {
    return CancelInvitationActionResponseFromJSONTyped(json, false);
}

export function CancelInvitationActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CancelInvitationActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'invitation': json['invitation'] == null ? undefined : CancelInvitationActionResponseInvitationFromJSON(json['invitation']),
    };
}

export function CancelInvitationActionResponseToJSON(json: any): CancelInvitationActionResponse {
    return CancelInvitationActionResponseToJSONTyped(json, false);
}

export function CancelInvitationActionResponseToJSONTyped(value?: CancelInvitationActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'invitation': CancelInvitationActionResponseInvitationToJSON(value['invitation']),
    };
}

